import React from "react";
import { FormattedMessage } from "react-intl";

interface InputProps {
    className?: string;
    label?: string;
    type?: string;
    value?: string;
    onChange?: (event: any) => void;
    name?: string;
    placeholder?: string;
    disabled?: boolean;
}

export const Input: React.FC<InputProps> = ({ className, label, type, value, name, placeholder, disabled, onChange }) => {

    return (
        type === "submit" ?
            <input disabled={disabled} name={name ? name : ''} className={className ? className : "inline-flex items-center justify-center px-6 py-4 mt-4 mb-4 w-1/2 border border-transparent shadow-sm font-bold rounded-3xl text-sm text-white text-center bg-primary hover:bg-secondary focus:outline-none disabled:bg-lightGrey"} type={type} value={value} onChange={onChange} />
            :
            <div className={className ? className : "w-full flex flex-col justify-between items-start p-6 py-5 text-left bg-white border border-primary border-opacity-40 rounded-xl mt-3"}>
                {
                    label !== undefined &&
                    <label
                        htmlFor={name}
                        className="block text-sm font-medium text-gray-900 left-6 top-5 "
                    >
                        <FormattedMessage id={label} />
                    </label>
                }
                {
                    type === "text" &&
                    <input disabled={disabled} readOnly={onChange === undefined} className="w-full border-0 p-0 italic text-black text-sm text-opacity-50 focus:ring-opacity-0 focus:ring-transparent" name={name ? name : ''} type={type} value={value} placeholder={placeholder ? placeholder : ""} onChange={onChange} />
                }
                {
                    type === "textarea" &&
                    <textarea disabled={disabled} readOnly={onChange === undefined} className="w-full border-0 p-0 italic text-black text-sm text-opacity-50 focus:ring-opacity-0 focus:ring-transparent" rows={5} name={name ? name : ''} value={value} placeholder={placeholder ? placeholder : ""} onChange={onChange} />
                }
            </div>
    );
}

export default Input;